export default "__VITE_ASSET__BDQ9wRgo__"